import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f9ccca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "handler"
}
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = {
  key: 0,
  class: "icon-btns"
}
const _hoisted_4 = { class: "element-list" }
const _hoisted_5 = {
  key: 0,
  class: "group-els"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-title" }, "组合", -1))
const _hoisted_7 = ["onClick", "onDblclick"]
const _hoisted_8 = ["id", "value", "onBlur", "onKeydown"]
const _hoisted_9 = {
  key: 1,
  class: "name"
}
const _hoisted_10 = { class: "icons" }
const _hoisted_11 = ["onClick", "onDblclick"]
const _hoisted_12 = ["id", "value", "onBlur", "onKeydown"]
const _hoisted_13 = {
  key: 1,
  class: "name"
}
const _hoisted_14 = { class: "icons" }

import { computed, nextTick, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore, useMainStore } from '@/store'
import { PPTElement } from '@/types/slides'
import { ELEMENT_TYPE_ZH } from '@/configs/element'
import useOrderElement from '@/hooks/useOrderElement'
import { ElementOrderCommands } from '@/types/edit'

import MoveablePanel from '@/components/MoveablePanel.vue'
import { Button, Input } from 'ant-design-vue'

interface GroupElements {
  type: 'group'
  id: string
  elements: PPTElement[]
}
type ElementItem = PPTElement | GroupElements


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectPanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const mainStore = useMainStore()
const { currentSlide } = storeToRefs(slidesStore)
const { handleElement, handleElementId, activeElementIdList, activeGroupElementId, hiddenElementIdList } = storeToRefs(mainStore)

const { orderElement } = useOrderElement()

const elements = computed<ElementItem[]>(() => {
  const _elements: ElementItem[] = []

  for (const el of currentSlide.value.elements) {
    if (el.groupId) {
      const lastItem = _elements[_elements.length - 1]

      if (lastItem && lastItem.type === 'group' && lastItem.id && lastItem.id === el.groupId) {
        lastItem.elements.push(el)
      }
      else _elements.push({ type: 'group', id: el.groupId, elements: [el] })
    }
    else _elements.push(el)
  }

  return _elements
})

const selectGroupEl = (item: GroupElements, id: string) => {
  if (handleElementId.value === id) return
  if (hiddenElementIdList.value.includes(id)) return

  const idList = item.elements.map(el => el.id)
  mainStore.setActiveElementIdList(idList)
  mainStore.setHandleElementId(id)
  nextTick(() => mainStore.setActiveGroupElementId(id))
}

const selectEl = (id: string) => {
  if (handleElementId.value === id) return
  if (hiddenElementIdList.value.includes(id)) return

  mainStore.setActiveElementIdList([id])
}

const hideElement = (id: string) => {
  if (hiddenElementIdList.value.includes(id)) {
    mainStore.setHiddenElementIdList(hiddenElementIdList.value.filter(item => item !== id))
  }
  else mainStore.setHiddenElementIdList([...hiddenElementIdList.value, id])

  if (activeElementIdList.value.includes(id)) mainStore.setActiveElementIdList([])
}

const showAll = () => {
  const currentSlideElIdList = currentSlide.value.elements.map(item => item.id)
  const needHiddenElementIdList = hiddenElementIdList.value.filter(item => !currentSlideElIdList.includes(item))
  mainStore.setHiddenElementIdList(needHiddenElementIdList)
}
const hideAll = () => {
  const currentSlideElIdList = currentSlide.value.elements.map(item => item.id)
  mainStore.setHiddenElementIdList([...hiddenElementIdList.value, ...currentSlideElIdList])
  if (activeElementIdList.value.length) mainStore.setActiveElementIdList([])
}

const editingElId = ref('')

const saveElementName = (e: FocusEvent | KeyboardEvent, id: string) => {
  const name = (e.target as HTMLInputElement).value
  slidesStore.updateElement({ id, props: { name } })
  editingElId.value = ''
}

const enterEdit = (id: string) => {
  editingElId.value = id
  nextTick(() => {
    const inputRef = document.querySelector(`#input-${id}`) as HTMLInputElement
    inputRef.focus()
  })
}

const close = () => {
  mainStore.setSelectPanelState(false)
}

return (_ctx: any,_cache: any) => {
  const _component_IconDown = _resolveComponent("IconDown")!
  const _component_IconUp = _resolveComponent("IconUp")!
  const _component_IconPreviewClose = _resolveComponent("IconPreviewClose")!
  const _component_IconPreviewOpen = _resolveComponent("IconPreviewOpen")!

  return (_openBlock(), _createBlock(MoveablePanel, {
    class: "select-panel",
    width: 200,
    height: 360,
    title: `选择（${_unref(activeElementIdList).length}/${_unref(currentSlide).elements.length}）`,
    left: -270,
    top: 90,
    onClose: _cache[4] || (_cache[4] = ($event: any) => (close()))
  }, {
    default: _withCtx(() => [
      (_unref(elements).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Button), {
                size: "small",
                style: {"margin-right":"5px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showAll()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全部显示")
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (hideAll()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全部隐藏")
                ]),
                _: 1
              })
            ]),
            (_unref(handleElement))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_IconDown, {
                    class: "icon-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).UP)))
                  }),
                  _createVNode(_component_IconUp, {
                    class: "icon-btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).DOWN)))
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(elements), (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (item.type === 'group')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.elements, (groupItem) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["item", {
              'active': _unref(activeElementIdList).includes(groupItem.id),
              'group-active': _unref(activeGroupElementId).includes(groupItem.id),
            }]),
                      key: groupItem.id,
                      onClick: ($event: any) => (selectGroupEl(item, groupItem.id)),
                      onDblclick: ($event: any) => (enterEdit(groupItem.id))
                    }, [
                      (editingElId.value === groupItem.id)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            id: `input-${groupItem.id}`,
                            value: groupItem.name || _unref(ELEMENT_TYPE_ZH)[groupItem.type],
                            class: "input",
                            type: "text",
                            onBlur: $event => saveElementName($event, groupItem.id),
                            onKeydown: _withKeys($event => saveElementName($event, groupItem.id), ["enter"])
                          }, null, 40, _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(groupItem.name || _unref(ELEMENT_TYPE_ZH)[groupItem.type]), 1)),
                      _createElementVNode("div", _hoisted_10, [
                        (_unref(hiddenElementIdList).includes(groupItem.id))
                          ? (_openBlock(), _createBlock(_component_IconPreviewClose, {
                              key: 0,
                              style: {"font-size":"17px"},
                              onClick: _withModifiers(($event: any) => (hideElement(groupItem.id)), ["stop"])
                            }, null, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_IconPreviewOpen, {
                              key: 1,
                              style: {"font-size":"17px"},
                              onClick: _withModifiers(($event: any) => (hideElement(groupItem.id)), ["stop"])
                            }, null, 8, ["onClick"]))
                      ])
                    ], 42, _hoisted_7))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["item", { 'active': _unref(activeElementIdList).includes(item.id) }]),
                  onClick: ($event: any) => (selectEl(item.id)),
                  onDblclick: ($event: any) => (enterEdit(item.id))
                }, [
                  (editingElId.value === item.id)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        id: `input-${item.id}`,
                        value: item.name || _unref(ELEMENT_TYPE_ZH)[item.type],
                        class: "input",
                        type: "text",
                        onBlur: $event => saveElementName($event, item.id),
                        onKeydown: _withKeys($event => saveElementName($event, item.id), ["enter"])
                      }, null, 40, _hoisted_12))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.name || _unref(ELEMENT_TYPE_ZH)[item.type]), 1)),
                  _createElementVNode("div", _hoisted_14, [
                    (_unref(hiddenElementIdList).includes(item.id))
                      ? (_openBlock(), _createBlock(_component_IconPreviewClose, {
                          key: 0,
                          style: {"font-size":"17px"},
                          onClick: _withModifiers(($event: any) => (hideElement(item.id)), ["stop"])
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_IconPreviewOpen, {
                          key: 1,
                          style: {"font-size":"17px"},
                          onClick: _withModifiers(($event: any) => (hideElement(item.id)), ["stop"])
                        }, null, 8, ["onClick"]))
                  ])
                ], 42, _hoisted_11))
          ], 64))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})